module.exports = __webpack_public_path__ + "img/file-1561657418244.196c57f8.png";